<template>
<div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">
    
    <div  style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
      
    <div style="width:40%;display:flex" > 
      <div style="width:4px;background-color:#970B0B;height:40px"></div> 
      <div style="margin:5px;color:#970B0B;">社刊管理</div> 
    </div>
    <div style="width:50%;justify-content: center;display: flex;">
    </div>
    <div style="width:15%;color:#970B0B">
        <el-button  @click="RightAddClick"  size="mini" style="width:70%;background-color:#970B0B;color:#fff">新增社刊</el-button> 

    </div>

    </div>

    </div>

<div style="width:100%;height:100%">
  

    <el-table 
    :data="periodicalIist"
        height="500px"
    size= "medium"
    style="width: 100%;height:100%;">
    <el-table-column
      fixed
      prop="id"
      label="序号"

      width="50">
    </el-table-column>
    <el-table-column
      prop="title"
      label="标题"
      width="300">
    </el-table-column>
    <el-table-column
      prop="contentType"
      label="文章类型"
      width="80">
    </el-table-column>
    <el-table-column
      prop="xcxVisible"
      label="状态"
      width="80">
    </el-table-column>
    <el-table-column
      prop="creator"
      label="发布人"
      width="100">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间"
      width="150">
    </el-table-column>
    <el-table-column
      prop="updater"
      label="更新人"
      width="100">
    </el-table-column>
    <el-table-column
      prop="updateTime"
      label="更新时间"
      width="150">
    </el-table-column>
    <el-table-column
      prop="readNum"
      label="浏览量"
      width="80">
    </el-table-column>
    <el-table-column
      fixed="right"
      label="操作"
      width="230">
     <template slot-scope="scope">
        <el-button v-if="scope.row.xcxVisible === '未下发' "
          size="mini"
          @click="handlePublish(scope.$index, scope.row)">下发</el-button>
        
        <el-button v-if="scope.row.xcxVisible === '已下发' "

          size="mini"
          @click="handleBack(scope.$index, scope.row)">撤回</el-button>
        <el-button
        <el-button
          size="mini"
          @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        <el-button
          size="mini"
          @click="handleDelete(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column>

  </el-table>
  


</div>


<!-- <el-pagination
style="text-align:right;margin:10px"
  background
  layout="prev, pager, next"
  :page-size="10"
  @current-change="handleCurrentChange"
  @prev-click="preclick"
  :total="20">
</el-pagination>
 -->

</div>

</template>

<script>
import TMApipath from 'TMApipath'
import TMStore from 'TMStore'
import {formatTime} from 'TMUtils'


  export default {
    mounted() {
      this.getAllPeriodiacl()

    },
    methods: {
      getAllPeriodiacl(){

          var _this = this
 let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.get(TMApipath.URL_CONTENT_LIST,{params: {token: TMStore.state.account.token,type:0}}).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {

               _this.periodicalIist =[];

              for(var items in response.data){
                var item = response.data[items]

                var cutFeed ={
                  xcxVisible: item.xcxVisible == 0 ? "已下发":"未下发",
                  createTime: formatTime(item.createTime),
                  creator: item.creator,
                  updateTime: item.updateTime ? formatTime(item.updateTime) : '--' ,
                  updater: item.updater ? item.updater : '--',
                  id: item.id,
                  readNum: item.readNum,
                  type: item.type,
                  coverPageImages: item.coverPageImages,
                  title: item.title,
                  summary:item.summary,
                  contentType: item.contentType ? '链接':'文本',
                  content: item.content
                }
                _this.periodicalIist.push(cutFeed);
              }


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      deletePeriodicalById(id){

          var _this = this
 let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.get(TMApipath.URL_CONTENT_DELETE,  {params:{id:id,token: TMStore.state.account.token,}}).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {

               _this.$message({
                  type: 'success',
                  message: '删除成功!'
                });

               _this.getAllPeriodiacl();

            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      handleDelete(index, rows) {
       var _this = this

        console.log(rows.id)

        _this.$confirm('此操作将永久删除该组, 是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          _this.deletePeriodicalById(rows.id)

        }).catch(() => {
                 
        });

      },
      handleEdit(index, rows) {

        this.$router.push({name: 'PeriodicalAdd',params:{id:rows.id,periodicalFlag:'edit'}});
      },
      handlePublish(index, rows) {//发布

        var _this = this

         var formData = {
          xcxVisible: 0,
          id: rows.id
          }
 let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(TMApipath.URL_CONTENT_UPDATE +'?token=' + TMStore.state.account.token ,  formData).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {

               _this.$message({
                  type: 'success',
                  message: '操作成功!'
                });

                _this.getAllPeriodiacl()

            }else{
              _this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });



      },
      handleBack(index, rows) {//撤回
         var _this = this

         var formData = {
          xcxVisible: 1,
          id: rows.id
          }
 let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(TMApipath.URL_CONTENT_UPDATE +'?token=' + TMStore.state.account.token ,  formData).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {

               _this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                 _this.getAllPeriodiacl()


            }else{
              _this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });



      },
      handleCurrentChange(val){
        console.log(`当前页: ${val}`);
      },
      RightAddClick(){

        this.$router.push({name: 'PeriodicalAdd',params:{periodicalFlag:'add'}});
      }

    },
    data() {
      return {
       periodicalIist: []
      }
    }
  }
</script>

<style lang="stylus" scoped>
.groups
    overflow: hidden

.rightButton
  width: 30px
.container_right
    margin: 5px
    display: flex
    justify-content: center
    align-items: flex-start
.el-dialog_header
    padding:0px

</style>